module.exports = __webpack_public_path__ + "img/mattca.0b709e80.jpg";